import Footer from "../../components/common/footer";
import HeaderTwo from "../../components/common/headerTwo";
import { Helmet } from "react-helmet";
import Offer3UslugaGlebogryzarki from "../../components/offer/3uslugaGlebogryzarki";

function K1MulczerLesny() {
  return (
    <>
      <Helmet>
        <title>Usługi glebogryzarką separacyjną pod trawnik | Gdańsk, Gdynia, Wejherowo, Kaszuby</title>
        <meta name="title" content="Usługi glebogryzarką separacyjną pod trawnik | Gdańsk, Gdynia, Wejherowo, Kaszuby" />
        <meta
          name="description"
          content="Przygotowanie gleby glebogryzarką separacyjną, która spulchnia ziemię i zakopuje kamienie pod trawnik. Pracujemy w Gdańsku, Gdyni, Kartuzach i na Kaszubach."
          key="desc"
        />
        <meta
          property="og:title"
          content="Usługi glebogryzarką separacyjną pod trawnik | Gdańsk, Gdynia, Wejherowo, Kaszuby"
        />
        <meta
          property="og:description"
          content="Przygotowanie gleby glebogryzarką separacyjną, która spulchnia ziemię i zakopuje kamienie pod trawnik. Pracujemy w Gdańsku, Gdyni, Kartuzach i na Kaszubach."
        />
        <meta
          property="og:image"
          content="https://magazyn.drzewus.pl/wp-content/uploads/2024/11/logo-white-10.55.05.png"
        />
      </Helmet>
      <HeaderTwo />
      <main className="relative z-40">
        <Offer3UslugaGlebogryzarki />
      </main>
      <Footer />
    </>
  );
}
export default K1MulczerLesny;
